import React, { useEffect } from 'react';
import ModalWrapper from '../ModalWrapper';

import ModalOutOfStockModelBody from './ModalOutOfStockModelBody';

const ModalOutOfStockModel = ({ isOpen, onCloseModal, selectedModel, selectedVersion }) => {

    useEffect(() => {
        if (isOpen) {
            document.querySelector('body').classList.add('hide-float-buttons');

            return () => {
                document.querySelector('body').classList.remove('hide-float-buttons');
            }
        }
    }, [isOpen]);

    return (
        <ModalWrapper isOpen={isOpen} cssClass="modal-out-of-stock-model">
            <ModalOutOfStockModelBody onCloseModal={onCloseModal} selectedModel={selectedModel} selectedVersion={selectedVersion} />
        </ModalWrapper>
    );
}

export default ModalOutOfStockModel;